// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1w7Vl","buttons":"styles_buttons__3xd92"};